import Image from 'next/image'

import { Card } from '@wartek-id/card'
import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import useToggleSdkContext from 'utils/useToogleSdk'

export function BannerUpdatedTargetPerilaku() {
  const toggles = useToggleSdkContext()
  const isUpdatedTargetPerilakuInfoEnabled =
    toggles?.['kinerja-updated-target-perilaku-info-enabled'] || false

  if (!isUpdatedTargetPerilakuInfoEnabled) return null

  return (
    <Card>
      <div className="flex gap-6 p-6">
        <div className="flex-shrink-0">
          <Image
            alt=""
            src="/illustrations/img-announcement-speaker.png"
            width={84}
            height={84}
            className="flex-shrink-0"
          />
        </div>
        <div className="flex flex-col gap-1 items-start">
          <Text variant="heading-sm">
            [Periode 2025] Kami memperbarui data Target Perilaku pada Praktik
            Kinerja Kepala Sekolah
          </Text>
          <Text variant="body">
            Diskusikan dengan Kepala Sekolah terkait pembaruan ini dan cek
            artikel Pusat Informasi untuk memeriksa pembaruan datanya.
          </Text>
          <Button
            variant="ghost"
            size="sm"
            as="a"
            href="https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id/articles/40695122010777-Tentang-Variabel-Pengelolaan-Kinerja-Kepala-Sekolah-PKKS"
            target="_blank"
            className="flex-shrink-0 -ml-2 hover:!bg-transparent"
          >
            Ke Pusat Informasi
          </Button>
        </div>
      </div>
    </Card>
  )
}
